import React,{useContext,useEffect,useState} from 'react';
import AdminLayoutt from './AdminLayout'
import AuthContext from '../../context/authContext/authContext';
import AdminContext from '../../context/adminContext/adminContext';
import VerSalon from './VerSalon';  

import { Container,Snackbar,Backdrop,CircularProgress, makeStyles, Fab } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import AddIcon from '@material-ui/icons/Add';

//ESTILOS
const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
      },
      add: {
        position: 'fixed',
        top: theme.spacing(10),
        right: theme.spacing(2),
      },
  }));
//ALERTAAAS
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }  



const VerMesas = (props) => {
     //EXTRAER CONTEXT AUTH
     const authContext = useContext(AuthContext);
     const {
         cliente,
         limpiarCarrito,
         carrito
            } = authContext; 
    //EXTRAER CONTEXT ADMIN
    const adminContext = useContext(AdminContext)
    const {
        pedidos,
        error,
        mensaje,
        getActivePedidos,
        resetMensaje,
        setMensaje
            } = adminContext;
     //ESTILOS
     const classes = useStyles()
     //STATE
     const [isloading, setisloading] = useState(false);
    //EFFECT 

    useEffect(() => {
        let mounted = true;
        if(mounted){
            if(cliente){
                if(cliente.admin === 'false'){
                    props.history.push('/client')
               }
               if(carrito.length > 0){
                limpiarCarrito(cliente)
            }  
                 
           }
           getActivePedidos();
        }
        return function cleanup() {
            mounted = false
        }
        
           // eslint-disable-next-line
     }, [cliente,mensaje]);
    
    //FUNCIONES
    const handleClose = () => {
        //FUNCION QUE REINICIA LOS MENSAJES
        setTimeout(() => {
            resetMensaje()
        }, 2000);
        
    }

    return ( 
        <AdminLayoutt>
            <Backdrop className={classes.backdrop} open={isloading} >
                    <CircularProgress color="inherit" />
                </Backdrop> 
                <div className={classes.add}>
                        <Fab color="secondary" aria-label="add" onClick={() => props.history.push('/admin/new_pedidoSalon')}>
                            <AddIcon />
                        </Fab>
                </div>
                <Container maxWidth ='lg'>
                    <Snackbar open={mensaje ? true : false} autoHideDuration={3000} 
                        onClose={handleClose}
                        anchorOrigin={ {vertical: 'top', horizontal: 'center'} }>
                        <Alert onClose={handleClose} severity="success">
                            {mensaje}
                        </Alert>
                    </Snackbar>
                    <Snackbar open={error ? true : false} autoHideDuration={3000} 
                        onClose={handleClose}
                        anchorOrigin={ {vertical: 'top', horizontal: 'center'} }>
                        <Alert onClose={handleClose} severity="error">
                            {mensaje}
                        </Alert>
                    </Snackbar>
                    <VerSalon pedidos={pedidos} setisloading={setisloading} setMensaje={setMensaje} isloading={isloading}/>
                </Container>
        </AdminLayoutt>
        
     );
}
 
export default VerMesas;